var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        ref: "reportContent",
        staticClass: "detail-wrap",
      },
      [
        _c(
          "el-form",
          { staticClass: "detail-form", attrs: { "label-width": "110px" } },
          [
            _c(
              "el-row",
              { attrs: { gutter: 16 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c("el-form-item", { attrs: { label: "活动编码：" } }, [
                      _vm._v(_vm._s(_vm.detail.actCode)),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c("el-form-item", { attrs: { label: "活动名称：" } }, [
                      _vm._v(_vm._s(_vm.detail.actName)),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c("el-form-item", { attrs: { label: "活动时间：" } }, [
                      _vm._v(_vm._s(_vm.activityTime)),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c("el-form-item", { attrs: { label: "负责人编码：" } }, [
                      _vm._v(_vm._s(_vm.detail.responseCode)),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c("el-form-item", { attrs: { label: "负责人名称：" } }, [
                      _vm._v(_vm._s(_vm.detail.responseName)),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c("el-form-item", { attrs: { label: "负责人组织：" } }, [
                      _vm._v(_vm._s(_vm.detail.responseOrgName)),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c("el-form-item", { attrs: { label: "分公司编码：" } }, [
                      _vm._v(_vm._s(_vm.detail.responseBranchCode)),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c("el-form-item", { attrs: { label: "分公司名称：" } }, [
                      _vm._v(_vm._s(_vm.detail.responseBranchName)),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c("el-form-item", { attrs: { label: "兑付率：" } }, [
                      _vm._v(_vm._s(_vm.detail.paymentRate)),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c("el-form-item", { attrs: { label: "费用兑付比：" } }, [
                      _vm._v(_vm._s(_vm.detail.feePaymentRatio)),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "block" },
          [
            _c("div", { staticClass: "block-title" }, [_vm._v("活动执行细则")]),
            _c("el-input", {
              attrs: {
                type: "textarea",
                rows: 4,
                readonly: "",
                resize: "none",
                placeholder: "—",
              },
              model: {
                value: _vm.detail.executeDetail,
                callback: function ($$v) {
                  _vm.$set(_vm.detail, "executeDetail", $$v)
                },
                expression: "detail.executeDetail",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "block" },
          [
            _c("div", { staticClass: "block-title" }, [_vm._v("关联协议模板")]),
            _c(
              "el-table",
              {
                staticClass: "report-table",
                attrs: {
                  data: _vm.detail.templateVos || [],
                  border: "",
                  stripe: "",
                  size: "small",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "agreeCode",
                    label: "协议模板编码",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "agreeName",
                    label: "协议模板名称",
                    align: "center",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "block" },
          [
            _c("div", { staticClass: "block-title" }, [_vm._v("金额信息")]),
            _c(
              "el-row",
              { staticClass: "amount-cards", attrs: { gutter: 16 } },
              [
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "amount-card" }, [
                    _c("div", { staticClass: "amount-label" }, [
                      _vm._v("活动申请金额"),
                    ]),
                    _c("div", { staticClass: "amount-value black" }, [
                      _vm._v("￥" + _vm._s(_vm.detail.appliedAmount || 0)),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "amount-card" }, [
                    _c("div", { staticClass: "amount-label" }, [
                      _vm._v("已发放金额"),
                    ]),
                    _c("div", { staticClass: "amount-value green" }, [
                      _vm._v("￥" + _vm._s(_vm.detail.paidAmount || 0)),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "amount-card" }, [
                    _c("div", { staticClass: "amount-label" }, [
                      _vm._v("未发放金额（将退回）"),
                    ]),
                    _c("div", { staticClass: "amount-value red" }, [
                      _vm._v(
                        " ￥" + _vm._s(_vm.detail.unpaidAmount || 0) + " "
                      ),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "block" },
          [
            _c("div", { staticClass: "block-title" }, [
              _vm._v(
                " 已发放奖励协议信息（" +
                  _vm._s((_vm.detail.paidShareVos || []).length) +
                  "条） "
              ),
            ]),
            _c(
              "el-table",
              {
                staticClass: "report-table",
                attrs: {
                  data: _vm.detail.paidShareVos || [],
                  border: "",
                  stripe: "",
                  size: "small",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "agreeCode",
                    label: "协议编码",
                    align: "center",
                    "min-width": "100",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "agreeName",
                    label: "协议名称",
                    align: "center",
                    "min-width": "100",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "terminalCode",
                    label: "终端编码",
                    align: "center",
                    "min-width": "100",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "terminalName",
                    label: "终端名称",
                    align: "center",
                    "min-width": "100",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "amount",
                    label: "发放金额",
                    align: "center",
                    "min-width": "100",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "block" },
          [
            _c("div", { staticClass: "block-title" }, [
              _vm._v(
                " 未发放奖励协议信息（" +
                  _vm._s((_vm.detail.unpaidShareVos || []).length) +
                  "条） "
              ),
            ]),
            _c(
              "el-table",
              {
                staticClass: "report-table",
                attrs: {
                  data: _vm.detail.unpaidShareVos || [],
                  border: "",
                  stripe: "",
                  size: "small",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "agreeCode",
                    label: "协议编码",
                    align: "center",
                    "min-width": "100",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "agreeName",
                    label: "协议名称",
                    align: "center",
                    "min-width": "100",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "terminalCode",
                    label: "终端编码",
                    align: "center",
                    "min-width": "100",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "terminalName",
                    label: "终端名称",
                    align: "center",
                    "min-width": "100",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "扫码是否达标",
                    align: "center",
                    "min-width": "100",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            _vm._s(scope.row.scanCodePass === "Y" ? "是" : "否")
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "taskPass",
                    label: "合格任务数量",
                    align: "center",
                    "min-width": "110",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "amount",
                    label: "退回金额（元）",
                    align: "center",
                    "min-width": "100",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "note" }, [
          _vm._v("注：未兑付终端，由分公司自行与终端协商处理。"),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "block report-block" },
      [
        _c("div", { staticClass: "block-title" }, [_vm._v("结算报告")]),
        _c("Upload", {
          attrs: {
            value: _vm.reportFiles,
            disabled: true,
            accept: ".pdf,.png,.jpg,.jpeg",
            fileMsg: "点击「生成结算报告」自动生成",
          },
          on: { getFileList: _vm.onReportFileList },
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "dialog-footer",
        attrs: { slot: "footer" },
        slot: "footer",
      },
      [
        !_vm.disabled
          ? _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  icon: "el-icon-document",
                  loading: _vm.generating,
                },
                on: { click: _vm.generateReport },
              },
              [_vm._v("生成结算报告")]
            )
          : _vm._e(),
        _vm.showCancel
          ? _c(
              "el-button",
              {
                attrs: { type: "danger", size: "small", icon: "el-icon-close" },
                on: { click: _vm.closeModal },
              },
              [_vm._v("关闭")]
            )
          : _vm._e(),
        !_vm.disabled
          ? _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  size: "small",
                  icon: "el-icon-check",
                },
                on: { click: _vm.confirmSettle },
              },
              [_vm._v("确认")]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }